import { useNavigate } from "react-router-dom";
import { currencyFormat } from "../shared/helpers/functions";

const HomeProduct = ({vehicle}) => {

  let navigate = useNavigate();

  function handleClick(event) {
    event.preventDefault();
    // Add your custom logic or actions here
    navigate(`/detalji/`+ vehicle.id);
  }

  return (
    <div className="home-product col-2">
      <a href={`/detalji/`+ vehicle.id} onClick={handleClick} className="product-card">
        <div className="product-image-container">
          <div className={`status-badge ${(vehicle?.status === "stock" && !vehicle?.in_arrival) ? "status-available" : vehicle?.status === "sold" ? "status-sold" : (vehicle?.status === "offer" || vehicle?.in_arrival) ? "status-coming" : ""}`}>
            {vehicle?.status === "stock" && vehicle?.in_arrival && <span>U dolasku</span>}
            {vehicle?.status === "stock" && !vehicle?.in_arrival && <span>Na stanju</span>}
            {vehicle?.status === "sold" && <span>Prodato</span>}
            {vehicle?.status === "offer" && <span>U dolasku</span>}
          </div>
          <img src={vehicle?.image_url} alt={vehicle?.full_name || 'Vehicle'} className="product-image"/>
          <div className="image-overlay"></div>
        </div>
        <div className="product-info-container">
          <h5 className="product-name">{vehicle?.full_name ?? ''}</h5>
          <p className="product-category">{vehicle?.category_name ?? ''}</p>
          <div className="product-details">
            <p className="product-year">{vehicle?.production_year > 1 ? vehicle?.production_year + ". godina" : '-'}</p>
            <p className="product-code">{(vehicle?.name ?? '').substring(2)}</p>
          </div>
          <div className="product-price-container">
            <h5 className="product-price">{vehicle?.show_price && vehicle?.price > 0 ? currencyFormat(vehicle?.price ?? 0) + " €" : 'Kontaktirajte nas'}</h5>
            {vehicle?.show_price && vehicle?.price > 0 && <p className="price-note">+ PDV</p>}
          </div>
          <div className={`status-text-mobile ${(vehicle?.status === "stock" && !vehicle?.in_arrival) ? "status-available" : vehicle?.status === "sold" ? "status-sold" : (vehicle?.status === "offer" || vehicle?.in_arrival) ? "status-coming" : ""}`}>
            {vehicle?.status === "stock" && vehicle?.in_arrival && <span>U dolasku</span>}
            {vehicle?.status === "stock" && !vehicle?.in_arrival && <span>Na stanju</span>}
            {vehicle?.status === "sold" && <span>Prodato</span>}
            {vehicle?.status === "offer" && <span>U dolasku</span>}
          </div>
        </div>
      </a>
    </div>
  );
}

export default HomeProduct;
